import { Component, OnInit } from "@angular/core";
import { BrillantsService } from "../service/brillants.service";
import { BrillantField, Steingroesse } from "cilor-db-api-shared";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";

@Component({
  selector: "app-brillants-page",
  templateUrl: "./brillants-page.component.html",
  styleUrls: ["./brillants-page.component.scss"]
})
export class BrillantsPageComponent implements OnInit {
  BrillantField = BrillantField;
  faSearch = faSearch;

  constructor(
    public readonly brillantService: BrillantsService,
  ) { }

  async ngOnInit(): Promise<void> {
    await this.brillantService.loadBrillants();
  }

  async previousPage(): Promise<void> {
    this.brillantService.pageIndex -= 1;
    await this.brillantService.loadBrillants();
  }

  canPreviousPage(): boolean {
    return this.brillantService.pageIndex > 0 && !this.brillantService.loading;
  }

  async nextPage(): Promise<void> {
    this.brillantService.pageIndex += 1;
    await this.brillantService.loadBrillants();
  }

  canNextPage(): boolean {
    if (this.brillantService.data == null) {
      return false;
    }
    return this.brillantService.pageIndex < this.brillantService.data.pageCount - 1 && !this.brillantService.loading;
  }

  async setSortPath(sortPath: string): Promise<void> {
    this.brillantService.sortPath = sortPath;
    await this.brillantService.loadBrillants();
  }

  public isLoading(): boolean {
    return this.brillantService.loading;
  }

  public async triggerSearch(): Promise<void> {
    try {
      this.brillantService.pageIndex = 0;
      await this.brillantService.loadBrillants();
    } catch (e) {
      alert(e.message);
    }
  }

  public steingroesseForDisplay(steingroesse: Steingroesse): string {
    switch (steingroesse) {
      case Steingroesse.stein0005: return "0,005 ct.";
      case Steingroesse.stein001: return "0,01 ct.";
      case Steingroesse.stein0015: return "0,015 ct.";
      case Steingroesse.stein002: return "0,02 ct.";
      case Steingroesse.stein0025: return "0,025 ct.";
      case Steingroesse.stein003: return "0,03 ct.";
      case Steingroesse.stein004: return "0,04 ct.";
      case Steingroesse.stein005: return "0,05 ct.";
      case Steingroesse.stein006: return "0,06 ct.";
      case Steingroesse.stein007: return "0,07 ct.";
      case Steingroesse.stein008: return "0,08 ct.";
      case Steingroesse.stein009: return "0,09 ct.";
      case Steingroesse.stein01: return "0,1 ct.";
      case Steingroesse.stein011: return "0,11 ct.";
      case Steingroesse.stein012: return "0,12 ct.";
      case Steingroesse.stein013: return "0,13 ct.";
      case Steingroesse.stein014: return "0,14 ct.";
      case Steingroesse.stein015: return "0,15 ct.";
      case Steingroesse.stein016: return "0,16 ct.";
      case Steingroesse.stein017: return "0,17 ct.";
      case Steingroesse.stein018: return "0,18 ct.";
      case Steingroesse.stein019: return "0,19 ct.";
      case Steingroesse.stein02: return "0,2 ct.";
      case Steingroesse.stein025: return "0,25 ct.";
      case Steingroesse.stein03: return "0,3 ct.";
      case Steingroesse.stein035: return "0,35 ct.";
      case Steingroesse.stein04: return "0,4 ct.";
      case Steingroesse.stein045: return "0,45 ct.";
      case Steingroesse.stein05: return "0,5 ct.";
      case Steingroesse.stein055: return "0,55 ct.";
      case Steingroesse.stein06: return "0,6 ct.";
      case Steingroesse.stein065: return "0,65 ct.";
      case Steingroesse.stein07: return "0,7 ct.";
      case Steingroesse.stein075: return "0,75 ct.";
      case Steingroesse.stein08: return "0,8 ct.";
      case Steingroesse.stein085: return "0,85 ct.";
      case Steingroesse.stein09: return "0,9 ct.";
      case Steingroesse.stein095: return "0,95 ct.";
      case Steingroesse.stein1: return "1 ct.";
    }
  }
}
